import { useNavigate } from "react-router-dom";
import { CheckCircle, Home } from "lucide-react";

const Success = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-orange-50 via-white to-orange-50/30 flex items-center justify-center px-4">
      <div className="max-w-2xl w-full">
        <div className="bg-white rounded-3xl shadow-xl shadow-orange-100/50 p-8 md:p-12 text-center animate-scale-in">
          <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6">
            <CheckCircle className="w-12 h-12 text-green-600" />
          </div>
          
          <h1 className="text-4xl font-bold text-gray-900 mb-4">
            Avaliação Concluída!
          </h1>
          
          <p className="text-lg text-gray-600 mb-8 leading-relaxed">
            Obrigado por completar a avaliação de riscos psicossociais. Suas respostas foram registradas com sucesso e contribuirão para melhorar o ambiente de trabalho.
          </p>

          <div className="bg-orange-50 border border-orange-200 rounded-2xl p-6 mb-8">
            <p className="text-gray-700">
              Os resultados serão analisados pela equipe de segurança do trabalho e recursos humanos. Ações preventivas e corretivas serão implementadas conforme necessário.
            </p>
          </div>

          <button
            data-testid="back-home-button"
            onClick={() => navigate("/")}
            className="flex items-center justify-center gap-2 px-8 py-3 bg-orange-500 text-white rounded-full hover:bg-orange-600 transition-all font-semibold shadow-lg shadow-orange-500/30 mx-auto"
          >
            <Home className="w-5 h-5" />
            Finalizar
          </button>
        </div>
      </div>
    </div>
  );
};

export default Success;